/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svchip_BillingInputs */

const en_svchip_billing = /** @type {(inputs: Svchip_BillingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Billing`)
};

const ar_svchip_billing = /** @type {(inputs: Svchip_BillingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الفوترة`)
};

const bn_svchip_billing = /** @type {(inputs: Svchip_BillingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`বিলিং`)
};

const de_svchip_billing = /** @type {(inputs: Svchip_BillingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abrechnung`)
};

const es_svchip_billing = /** @type {(inputs: Svchip_BillingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Facturación`)
};

const fr_svchip_billing = /** @type {(inputs: Svchip_BillingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Facturation`)
};

const pt_svchip_billing = /** @type {(inputs: Svchip_BillingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Faturamento`)
};

const zh_svchip_billing = /** @type {(inputs: Svchip_BillingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`计费`)
};

const tr_svchip_billing = /** @type {(inputs: Svchip_BillingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Faturalandırma`)
};

const ru_svchip_billing = /** @type {(inputs: Svchip_BillingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Оплата`)
};

const pl_svchip_billing = /** @type {(inputs: Svchip_BillingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rozliczenia`)
};

/**
* | output |
* | --- |
* | "Billing" |
*
* @param {Svchip_BillingInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svchip_billing = /** @type {((inputs?: Svchip_BillingInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svchip_BillingInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svchip_billing(inputs)
	if (locale === "bn") return bn_svchip_billing(inputs)
	if (locale === "de") return de_svchip_billing(inputs)
	if (locale === "es") return es_svchip_billing(inputs)
	if (locale === "fr") return fr_svchip_billing(inputs)
	if (locale === "pt") return pt_svchip_billing(inputs)
	if (locale === "zh") return zh_svchip_billing(inputs)
	if (locale === "tr") return tr_svchip_billing(inputs)
	if (locale === "ru") return ru_svchip_billing(inputs)
	if (locale === "pl") return pl_svchip_billing(inputs)
	return en_svchip_billing(inputs)
});